import {Directive, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {HigherEducationInstitutionTypesService} from '../higher-education-institution-types.service';
import {HigherEducationInstitutionType} from './higher-education-institution-type';
import {Results} from '../../core/results';
declare var $: any;
@Directive({
  selector: '[appHigherEducationInstitutionType]',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => HigherEducationInstitutionTypeDirective),
    multi: true
  }]
})
export class HigherEducationInstitutionTypeDirective implements ControlValueAccessor, OnInit {

  @Input() private higherEducationInstitutionType: HigherEducationInstitutionType;
  @Input() private disabled = false;
  @Input() private checkOpened = false;
  @Output() onSelect: EventEmitter<any> = new EventEmitter();
  select2: any;

  constructor(private el: ElementRef, private service: HigherEducationInstitutionTypesService) {
  }

  ngOnInit(): void {
    const that = this;
    this.select2 = $(this.el.nativeElement).select2({
      width: '100%',
      placeholder: 'Higher Education Institution Type',
      allowClear: true,
      disabled: that.disabled,
      ajax: {
        transport: function(params, success, failure) {
          const page = 1;
          const perPage = 10;

          if(that.checkOpened === true) {
            that.service.searchOpened(page, perPage, 'ASC', 'name', params.data.term).subscribe((ret: Results<HigherEducationInstitutionType>) => {
              success(ret);
            });
          } else {
            that.service.search(page, perPage, 'ASC', 'name', params.data.term).subscribe((ret: Results<HigherEducationInstitutionType>) => {
              success(ret);
            });
          }


        },
        dataType: 'json',
        type: 'GET',
        processResults: function(data) {
          const arr = [];
          data.content.forEach(function(obj) {
            arr.push({
              id: JSON.stringify(obj),
              text: obj.name,
            });
          });
          return {
            results: arr
          };
        }
      }
    });
    $(this.el.nativeElement).on('select2:select', function(e) {

      that.higherEducationInstitutionType = JSON.parse(e.params.data.id);
      that.propagateChange(that.higherEducationInstitutionType);
      if(that.onSelect) {
        that.onSelect.emit();
      }

    });

    $(this.el.nativeElement).on('select2:unselect', function(e) {

      that.higherEducationInstitutionType = null;
      that.propagateChange(that.higherEducationInstitutionType);
      if(that.onSelect) {
        that.onSelect.emit();
      }
    });


  }

  onTouched = () => {
  };

  propagateChange = (_: any) => {
  };

  writeValue(higherEducationInstitutionType: HigherEducationInstitutionType): void {

    this.higherEducationInstitutionType = higherEducationInstitutionType;
    this.propagateChange(this.higherEducationInstitutionType);
    const that = this;
    if (this.higherEducationInstitutionType !== undefined && this.higherEducationInstitutionType !== null) {
      const option = new Option(higherEducationInstitutionType.name, JSON.stringify(higherEducationInstitutionType), true, true);
      that.select2.append(option);
      that.select2.trigger('change');
    }

  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  get value(): any {
    return this.higherEducationInstitutionType;
  }

  set value(v: any) {
    if (v !== this.higherEducationInstitutionType) {
      this.higherEducationInstitutionType = v;
      this.propagateChange(v);
    }
  }

}
